import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import kilt1 from "../assets/kil1.png";
import kilt2 from "../assets/kil2.png";
import kilt3 from "../assets/kilt3.jpg";

gsap.registerPlugin(ScrollTrigger);

const CraftSection = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const steps = sectionRef.current.querySelectorAll(".step");
    steps.forEach((step) => {
      const image = step.querySelector(".step-image-container");
      const content = step.querySelector(".step-content");

      gsap.fromTo(
        image,
        { opacity: 0, x: -100 },
        {
          opacity: 1,
          x: 0,
          duration: 1.2,
          ease: "power3.out",
          scrollTrigger: {
            trigger: step,
            start: "top 70%",
            toggleActions: "play none none none",
          },
        }
      );

      gsap.fromTo(
        content,
        { opacity: 0, x: 100 },
        {
          opacity: 1,
          x: 0,
          duration: 1.2,
          ease: "power3.out",
          scrollTrigger: {
            trigger: step,
            start: "top 70%",
            toggleActions: "play none none none",
          },
        }
      );
    });
  }, []);

  return (
    <section className="py-12 md:py-40 bg-background overflow-hidden" ref={sectionRef}>
      <div className="container mx-auto px-4">
        <h2 className="font-serif text-[clamp(2.5rem,8vw,8rem)] leading-none text-center mb-12 md:mb-32 font-bold text-primary">The Art of the Kilt</h2>
        <div className="flex flex-col gap-12 md:gap-48">
          <div className="step group grid grid-cols-1 md:grid-cols-2 items-center gap-6 md:gap-16">
            <div className="step-image-container overflow-hidden rounded-lg aspect-[4/3]">
              <img
                src={kilt1}
                alt="A precise and personal fitting for a bespoke kilt"
                className="w-full h-full object-cover rounded-lg transition-transform duration-[600ms] ease-[cubic-bezier(0.19,1,0.22,1)] group-hover:scale-105"
              />
            </div>
            <div className="step-content text-left">
              <span className="block text-2xl font-bold text-primary mb-4">01</span>
              <h3 className="text-3xl md:text-[3.5rem] font-serif mb-4 md:mb-8">The Measurement</h3>
              <p className="text-lg leading-[1.8] max-w-[500px]">
                A precise and personal fitting to ensure a flawless silhouette.
                We capture every detail to begin crafting a kilt that is
                uniquely yours.
              </p>
            </div>
          </div>
          <div className="step group grid grid-cols-1 md:grid-cols-2 items-center gap-6 md:gap-16">
            <div className="step-image-container overflow-hidden rounded-lg aspect-[4/3] md:order-last">
              <img
                src={kilt2}
                alt="Master kiltmakers meticulously hand-pleating the tartan"
                className="w-full h-full object-cover rounded-lg transition-transform duration-[600ms] ease-[cubic-bezier(0.19,1,0.22,1)] group-hover:scale-105"
              />
            </div>
            <div className="step-content text-left">
              <span className="block text-2xl font-bold text-primary mb-4">02</span>
              <h3 className="text-3xl md:text-[3.5rem] font-serif mb-4 md:mb-8">The Pleating</h3>
              <p className="text-lg leading-[1.8] max-w-[500px]">
                Our master kiltmakers meticulously hand-pleat the tartan, a
                time-honored skill that gives our kilts their signature form and
                movement.
              </p>
            </div>
          </div>
          <div className="step group grid grid-cols-1 md:grid-cols-2 items-center gap-6 md:gap-16">
            <div className="step-image-container overflow-hidden rounded-lg aspect-[4/3]">
              <img
                src={kilt3}
                alt="Every stitch, buckle, and strap is applied with expert care"
                className="w-full h-full object-cover rounded-lg transition-transform duration-[600ms] ease-[cubic-bezier(0.19,1,0.22,1)] group-hover:scale-105"
              />
            </div>
            <div className="step-content text-left">
              <span className="block text-2xl font-bold text-primary mb-4">03</span>
              <h3 className="text-3xl md:text-[3.5rem] font-serif mb-4 md:mb-8">The Finishing</h3>
              <p className="text-lg leading-[1.8] max-w-[500px]">
                Every stitch, buckle, and strap is applied with expert care,
                ensuring your kilt is not just a garment, but a masterpiece of
                Scottish heritage.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CraftSection;
